module.exports = __webpack_public_path__ + "img/111.5412df29.jpg";